import React from "react";
import "./InterviewSubmitSuccess.scss";
import Header from "../../Common/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import ProgressBar from "react-bootstrap/ProgressBar";
import useInterviewSubmitReviewSuccess from "./useInterviewSubmitReviewSuccess";
import MainLayout from "../../Common/MainLayout";

function InterviewSubmitSuccess() {
  const { onAssessmentKitsClick, onGoToHomeClick } =
    useInterviewSubmitReviewSuccess();
  return (
    <MainLayout pageName={"Interview Submit"}>
      <div className="interview-success-wrapper">
        <div className="container mt-5">
          <div className="d-flex align-items-center p-4 justify-content-center">
            <div className="border text-center px-3 interview-inner mx-auto">
              <div className="border-bottom py-4">
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="success-icon text-primary"
                />
                <h2 className="mt-4">
                  Thanks for sharing this interview with Zydelo
                </h2>
                <p className="text-grey-4 mt-3 mb-0">
                  We’ll be watching your interview soon and will contact you
                  about the next steps
                </p>
              </div>
              {/* <div className="py-4">
                <p className="text-grey-4">Would you like the video recordings emailed to you?</p>
                <ul className="d-flex align-items-center justify-content-center">
                  <li>
                    <button className="btn btn-outline-light mr-3">Email recordings</button>
                  </li>
                  <li>
                    <button className="btn btn-primary">No Thanks</button>
                  </li>
                </ul>
              </div> */}
              <div className="py-4">
                <ul className="d-flex align-items-center justify-content-center">
                  <li>
                    <button
                      className="btn btn-outline-light mr-3"
                      onClick={onGoToHomeClick}
                    >
                      Go to Home
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn btn-primary mr-3"
                      onClick={onAssessmentKitsClick}
                    >
                      View more Assessments
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default InterviewSubmitSuccess;
